import React, { useRef, useState } from "react";
import cn from "classnames";
import styled from "styled-components";
import Vimeo from "@u-wave/react-vimeo";
import { RotatingLines } from "react-loader-spinner";

interface IVideoProps {
  vimeoId: string;
  controls?: boolean;
  playAllow?: boolean;
}

const VideoBox = (props: IVideoProps) => {
  const [togglePlay, setTogglePlay] = useState(true);
  const [isPlay, setPlay] = useState(props.playAllow);
  const [isReady, setIsReady] = useState(false);

  const toggleVideo = () => {
    if (isPlay) {
      setTogglePlay(!togglePlay);
    }
  };

  return (
    <VideoWrap className="video-wrap">
      {props.vimeoId ? (
        <>
          {isReady ? null : (
            <p className={"vimeo-spinner"} style={{ textAlign: "center" }}>
              <RotatingLines width="20" strokeColor="#00263e" strokeWidth="1" />
            </p>
          )}
          <Vimeo
            className={"vimeo-iframe"}
            video={`https://player.vimeo.com/video/${props.vimeoId}?app_id=58479`}
            controls={props.controls ? true : false}
            paused={togglePlay}
            loop
            playsInline={true}
            onReady={() => {
              setIsReady(true);
            }}
            // muted={true}
            autoplay={false}
          />
          <div className="play-btn" onClick={toggleVideo}>
            <span className="hidden">비디오선택</span>
          </div>
        </>
      ) : (
        <div>영상 정보가 잘못되었습니다.</div>
      )}
    </VideoWrap>
  );
};

const VideoWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
  .vimeo-iframe {
    width: 100%;
    height: 100%;
    > iframe {
      overflow: hidden;
      width: 100%;
      height: 100%;
      vertical-align: top;
      /* pointer-events: none; */
    }
  }
  .vimeo-spinner {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    justify-content: center;
  }
  .play-btn {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /* &::before {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      display: inline-block;
      width: 64px;
      height: 64px;
      margin: -32px 0 0 -32px;
      border: 1px solid #f00;
    }
    &.playing {
      &::before {
        border: 1px solid #ff0;
      }
    } */
  }
`;

export default VideoBox;
